import React, { useCallback, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import Section from './Section';

export const onChangeItem = ({ section, onChange }) => ({ value, previousValue, itemSlug }) => onChange({
  section,
  itemSlug,
  value,
  previousValue,
});

const renderSection = ({ onChange, sections, onValidateSection, shouldValidate, children }) => (key) =>
  <Section
    key={key}
    onChangeItem={onChangeItem({ section: key, onChange })}
    section={sections[key]}
    onValidateSection={onValidateSection({ sectionSlug: key })}
    shouldValidate={shouldValidate}
    intlKey={key}
  >
    { children }
  </Section>;

const indexOrder = ({ sections }) => (key1, key2) => sections[key1].index < sections[key2].index ? -1 : 1;

export const DynamicForm = ({ sections, onChange, shouldValidate, onValidate, children }) => {
  const keys = Object.keys(sections).sort(indexOrder({ sections }));

  const [sectionsValidity, setSectionsValidity] = useState({});

  const isDynamicFormValid = useMemo(
    () => Object.values(sectionsValidity).every(Boolean),
    [sectionsValidity]
  );

  const onValidateSection = useCallback(({ sectionSlug }) => (isValid) => {
    if (sectionsValidity[sectionSlug] !== isValid) {
      setSectionsValidity({ ...sectionsValidity, [sectionSlug]: isValid });
    }
  }, [sectionsValidity]);

  useEffect(() => {
    if (shouldValidate) {
      onValidate(isDynamicFormValid);
    }
  }, [shouldValidate, isDynamicFormValid]);

  return keys.map(renderSection({ onChange, sections, onValidateSection, shouldValidate, children }));
};

DynamicForm.propTypes = {
  sections: PropTypes.shape({
    name: PropTypes.string,
    index: PropTypes.number,
    items: PropTypes.array,
  }),
  onChange: PropTypes.func,
  onValidate: PropTypes.func,
  shouldValidate: PropTypes.bool,
};

export default DynamicForm;
